
import {Layout} from 'antd';
import {useMemo} from 'react';
import SideBar from '@/components/sideBar';
import HeadBar from '@/components/headBar';
import {useUserSession, SessionStore, ConfigStore} from '@/hooks';
import {getProjectType} from '@/utils';
import './app.less';
const {Header, Sider, Content} = Layout;
const App = () => {
    const appType = getProjectType();
    const session = useUserSession(appType !== 'publicCloudManager');
    const app = useMemo(() => {
        return JSON.parse(process.env.projectConfig);
    }, [process.env.projectConfig]
    );
    return (
        <ConfigStore.Provider value={app}>
            <SessionStore.Provider value={session}>
                <div className={`idaas-frontend-framework ${appType}`}>
                    <Layout>
                        {
                            appType !== 'publicCloudManager'
                            && <Header>
                                <HeadBar />
                            </Header>
                        }
                        <Layout>
                            {
                                !app.resetPassHiddenSideBar
                                && !session?.user?.needResetPassword
                                && <Sider width="180">
                                    <SideBar />
                                </Sider>
                            }
                            <Content>
                                <div
                                    id="idass-frontend-framework__main"
                                    className="hidden-bar"
                                >
                                </div>
                                <div
                                    id="idass-frontend-framework__main_new"
                                    className="hidden-bar"
                                >
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
            </SessionStore.Provider>
        </ConfigStore.Provider>
    );

};

export default App;
